var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloseColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_577_1379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.947952 9.93744C0.70278 9.9517 0.461663 9.87019 0.275444 9.71011C-0.0918148 9.34067 -0.0918148 8.74399 0.275444 8.37455L8.31722 0.332744C8.6992 -0.0246894 9.29859 -0.00481991 9.65603 0.377162C9.97924 0.722587 9.99808 1.25351 9.70013 1.62096L1.61098 9.71011C1.42716 9.86788 1.18991 9.94923 0.947952 9.93744Z",
    fill: "#5E6366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98029 9.93746C8.73181 9.9364 8.49366 9.83777 8.31723 9.66278L0.275429 1.62095C-0.0648176 1.22362 -0.0185593 0.625662 0.378769 0.285384C0.733396 -0.0183051 1.2564 -0.0183051 1.61099 0.285384L9.70015 8.32719C10.082 8.68472 10.1018 9.28414 9.74425 9.66603C9.73003 9.68122 9.71534 9.69591 9.70015 9.71013C9.50208 9.88238 9.2414 9.96469 8.98029 9.93746Z",
    fill: "#5E6366"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_577_1379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseColor);
export default __webpack_public_path__ + "static/media/ICON_CLOSE_COLOR.e902ff8a655b8522f99dc0840c9c2ef8.svg";
export { ForwardRef as ReactComponent };